<div [formGroup]="formGroup">
  <div class="row mb-4">
    <div class="d-flex justify-content-start col-12">
      <div class="d-flex flex-column align-items-center hover-effect hover" (click)="fileInput.click()">
        <input type="file" #fileInput hidden accept="image/*" (change)="onLogoSelected($event)">
        <div>
          @if (formGroup.get('iconUrl')?.value) {
            <img class="img-fluid" [src]="formGroup.get('iconUrl')?.value" alt="Integration App Logo" 
              style="max-width: 128px; max-height: 128px; border-radius: 10px;">
          } @else {
            <div class="d-flex align-items-center justify-content-center text-center" 
              style="width: 128px; height: 128px; border: 2px dashed #ccc; border-radius: 10px;">
              <span style="color: #737373;">128 x 128 px</span>
            </div>
          }
        </div>
          @if (formGroup.get('iconUrl')?.value) {
            <span class="mt-1" >{{ 'integration-app-information-form_edit_logo_text' | i18next }}</span>
          } @else {
            <span class="mt-1" [class.text-danger]="formGroup.get('iconUrl')?.touched && formGroup.get('iconUrl')?.invalid">
              {{ 'integration-app-information-form_add_logo_text' | i18next }}</span>
          }
      </div>
    </div>
  </div>
  <div class="row">
    <app-input-text class="col-12 col-md-6" [control]="formGroup.get('name')!" name="app_name"></app-input-text>
    <app-input-text class="col-12 col-md-6" [control]="formGroup.get('vendor')!" name="vendor"></app-input-text>
    <app-input-text class="col-12 col-md-6" [control]="formGroup.get('supportEmail')!" name="support_email"></app-input-text>
    <app-input-text class="col-12 col-md-6" [control]="formGroup.get('documentationUrl')!" name="documentation_url">
      <p-inputgroup-addon input-prefix [style]="{'background-color': '#eee'}">
        <span class="text-default">{{ selectedProtocol }}</span>
      </p-inputgroup-addon>
    </app-input-text>
    <app-input-text class="col-12 col-md-6" [control]="formGroup.get('websiteUrl')!" name="website_url">
      <p-inputgroup-addon input-prefix [style]="{'background-color': '#eee'}">
        <span class="text-default">{{ selectedProtocol }}</span>
      </p-inputgroup-addon>
    </app-input-text>
    <app-input-text class="col-12 col-md-6" [control]="formGroup.get('privacyPolicyUrl')!" name="privacy_policy_url">
      <p-inputgroup-addon input-prefix [style]="{'background-color': '#eee'}">
        <span class="text-default">{{ selectedProtocol }}</span>
      </p-inputgroup-addon>
    </app-input-text>
    <app-input-textarea class="col-12" [control]="formGroup.get('description')!" name="description" [options]="{ cols: '30', rows: '5', minlength: '50', maxlength: '3000' }"></app-input-textarea>
  </div>
</div>